import React from 'react'
import { shallow } from 'enzyme'
import AdminList from '../AdminList'
import AdminCircle from '../AdminCircle'

describe('<AdminList />', () => {
  const props = {
    admins: [
      { name: 'test 1', rid: 1 },
      { name: 'test 2', rid: 2 }
    ]
  }
  it('should render one <AdminCircle /> for each entry in its `admins` prop', () => {
    const wrapper = shallow(<AdminList {...props} />)
    expect(wrapper.find(AdminCircle)).toHaveLength(props.admins.length)
  })
})
